import React from 'react';
import { BillingHistoryView, BillingHistoryViewProps } from './BillingHistory.view';

export type BillingHistoryControllerProps = BillingHistoryViewProps & {
  // ...
};

export const BillingHistoryController = (props: BillingHistoryControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const viewProps: BillingHistoryViewProps = { ...props };
  return <BillingHistoryView {...viewProps} />;
};
